import React from 'react';
import ReactDOM from 'react-dom';

// import setAuthorizationToken from  './utils/setAuthorizationToken'
import App from './App.jsx';



// setAuthorizationToken(localStorage.jwtToken)


ReactDOM.render(
    <App />,
  document.getElementById('root')
);

